import React from 'react';
import LinkIntercept from 'components/linkIntercept/LinkIntercept';
import styled from 'styled-components';
import htmlParser from 'utils/html/htmlParser';

import ThemeBoxPackages from './ThemeBoxPackages';

import { mediaQueries } from 'styles/utils/mediaQueries';
import { rgba } from 'polished';

const ThemeBox = ({ id, slug, name, text, image, color, packages, airlineWhitelabel }) => (
  <Container image={image} color={color}>
    <LinkIntercept to={slug}>
      <Title airlineWhitelabel={airlineWhitelabel}>{name}</Title>
      <Description>{htmlParser(text)}</Description>
    </LinkIntercept>
    <ThemeBoxPackagesWrap>
      <ThemeBoxPackages packages={packages} themeId={id} />
    </ThemeBoxPackagesWrap>
  </Container>
);

export default ThemeBox;

const Container = styled.div`
  width: 864px;
  height: 513px;
  position: relative;
  margin: 0 auto 300px;
  padding: 49px 64px;
  background: ${({ image, color }) => `
    linear-gradient(${rgba(color, 0.9)} 0%, ${rgba(color, 0.9)} 100%),
    url(${image})
  `};
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 16px;

  ${mediaQueries.fromAndBelow.desktop`
    width: 100%;
  `}

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;
    height: initial;
    margin: 0 auto 65px;
    padding: 28px 25px;
  `}
`;

const Title = styled.h1`
  margin-bottom: 25px;
  font-family: ${({ theme, airlineWhitelabel }) =>
    airlineWhitelabel && airlineWhitelabel.isAirMalta ? theme.fonts.montserrat : theme.fonts.display};
  font-size: 48px;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.text.white};
`;

const Description = styled.div`
  width: 287px;
  max-height: 328px;
  overflow: hidden;

  p {
    color: ${({ theme }) => theme.colors.text.white};
    font-size: 16px;
    font-weight: 500;
    line-height: 1.6rem;
  }
`;

const ThemeBoxPackagesWrap = styled.div`
  width: 304px;
  position: absolute;
  right: 63px;
  bottom: -189px;

  ${mediaQueries.fromAndBelow.tablet`
    margin-top: 95px;
    position: initial;
    right: initial;
    bottom: initial;
  `}
`;
